import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { company } from "../../mock";
import Reveal from "../Reveal";

export default function CTASection() {
  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-[#0b1f3a] px-8 py-14 sm:px-14 text-center">
            <div className="absolute -top-20 -right-20 h-72 w-72 rounded-full bg-[#c6a15b]/15 blur-3xl" />
            <div className="absolute -bottom-20 -left-20 h-72 w-72 rounded-full bg-[#c6a15b]/15 blur-3xl" />
            <div className="relative max-w-2xl mx-auto">
              <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-white">
                Ready to Get Funded?
              </h2>
              <p className="mt-4 text-slate-300 text-lg">
                Tell us about your scenario and our team will match you with the right loan program.
                No obligation, free consultation — funding in 72 hours or less.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
                <Link
                  to="/apply"
                  className="group inline-flex items-center justify-center gap-2 rounded-md bg-[#c6a15b] px-7 py-3.5 font-bold text-[#0b1f3a] hover:bg-[#d8bc85] transition-colors"
                >
                  Apply Now
                  <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
                </Link>
                <a
                  href={`tel:${company.phoneTel}`}
                  className="inline-flex items-center justify-center gap-2 rounded-md border border-white/25 px-7 py-3.5 font-semibold text-white hover:bg-white/10 transition-colors"
                >
                  <Phone className="h-5 w-5" /> {company.phoneDisplay}
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
